export default __webpack_public_path__ + "static/media/logo.20ff9d3c.svg";